<div class="configurationBannerHeader" (click)="toggleExpansion()">
  <label class="configurationBannerLabel">Cabinet Features</label>
  <span class="spacer"></span>
  <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
</div>
@if (!collapsed) {
  <div class="selectionsWrapper">
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (drainPanSelection) {
          <span>
            <label class="halfWidthInputLabel">Drain Pan:</label>
            <select class="halfWidthInputField" #drainPanInput
              [class.invalidConfigurationSelection]="isInvalidSelection(drainPanSelection.Name)"
              (change)="selectedValueChanged(drainPanSelection.Name, drainPanInput.value)"
              [value]="drainPanSelection.Value.toString()">
              @for (allowable of drainPanSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="drainPanSelection.Value && drainPanSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="fullWidthConfigurationInput">
        @if (dripLipSelection) {
          <span>
            <label [class.invalidConfigurationSelection]="isInvalidSelection(dripLipSelection.Name)"
            for="dripLipInput" class="halfWidthInputLabel">Drip Lip:</label>
            <input type="checkbox" class="checkboxInput" id="dripLipInput"
              #dripLipInput [checked]="'true' === dripLipSelection.Value"
              (change)="selectedValueChanged(dripLipSelection.Name, dripLipInput.checked.toString())">
          </span>
        }
        @if (cabinetHeightSelection) {
          <span>
            <label class="halfWidthInputLabel">Cabinet Height:</label>
            <select class="halfWidthInputField" #cabinetHeightInput
              [class.invalidConfigurationSelection]="isInvalidSelection(cabinetHeightSelection.Name)"
              (change)="selectedValueChanged(cabinetHeightSelection.Name, cabinetHeightInput.value)"
              [value]="cabinetHeightSelection.Value.toString()">
              @for (allowable of cabinetHeightSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="cabinetHeightSelection.Value && cabinetHeightSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (cabinetInsulationSelection) {
          <span>
            <label class="halfWidthInputLabel">Cabinet Insulation:</label>
            <select class="halfWidthInputField" #cabinetInsulationInput
              [class.invalidConfigurationSelection]="isInvalidSelection(cabinetInsulationSelection.Name)"
              (change)="selectedValueChanged(cabinetInsulationSelection.Name, cabinetInsulationInput.value)"
              [value]="cabinetInsulationSelection.Value.toString()">
              @for (allowable of cabinetInsulationSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="cabinetInsulationSelection.Value && cabinetInsulationSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="fullWidthConfigurationInput">
        @if (secondaryDrainConnection) {
          <span>
            <label [class.invalidConfigurationSelection]="isInvalidSelection(secondaryDrainConnection.Name)"
            for="secondaryDrainInput" class="halfWidthInputLabel">Secondary Drain Connection:</label>
            <input type="checkbox" class="checkboxInput" id="secondaryDrainInput"
              #secondaryDrainInput [checked]="'true' === secondaryDrainConnection.Value"
              (change)="selectedValueChanged(secondaryDrainConnection.Name, secondaryDrainInput.checked.toString())">
          </span>
        }
        @if (cabinetUpsizingSelection) {
          <span>
            <label class="halfWidthInputLabel">Cabinet Upsizing:</label>
            <select class="halfWidthInputField" #cabinetUpsizingInput
              [class.invalidConfigurationSelection]="isInvalidSelection(cabinetUpsizingSelection.Name)"
              (change)="selectedValueChanged(cabinetUpsizingSelection.Name, cabinetUpsizingInput.value)"
              [value]="cabinetUpsizingSelection.Value.toString()">
              @for (allowable of cabinetUpsizingSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="cabinetUpsizingSelection.Value && cabinetUpsizingSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput"></span>
      <span class="fullWidthConfigurationInput">
        @if (mountingLegsSelection) {
          <span>
            <label [class.invalidConfigurationSelection]="isInvalidSelection(mountingLegsSelection.Name)"
            for="mountingLegsInput" class="halfWidthInputLabel">Mounting Legs:</label>
            <input type="checkbox" class="checkboxInput" id="mountingLegsInput"
              #mountingLegsInput [checked]="'true' === mountingLegsSelection.Value"
              (change)="selectedValueChanged(mountingLegsSelection.Name, mountingLegsInput.checked.toString())">
          </span>
        }
        @if (riserChaseSelection) {
          <span>
            <label class="halfWidthInputLabel">Riser Chase:</label>
            <select class="halfWidthInputField" #riserChaseInput
              [class.invalidConfigurationSelection]="isInvalidSelection(riserChaseSelection.Name)"
              (change)="selectedValueChanged(riserChaseSelection.Name, riserChaseInput.value)"
              [value]="riserChaseSelection.Value.toString()">
              @for (allowable of riserChaseSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="riserChaseSelection.Value && riserChaseSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
  </div>
}
